import React, { useEffect, useState } from 'react';
import Header from '../Header/AppHeader';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../QuotationRecords/QuotationStyle.css';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import Select from 'react-select';
import { FetchUsers } from '../Common/Services/UserService';
import DataTable from '../Common/DataTableList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faSearch } from '@fortawesome/free-solid-svg-icons';

const TrackRecords = () => {

    const [TrackLogData, setTrackLogData] = useState([]);
    const [FilterTrackLogData, setFilterTrackLogData] = useState([]);
    const [PartnerUsers, setPartnerUsers] = useState([]);

    useEffect(() => {
        FetchTrackLogs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const Failure = (err) => {
        FailureAlert(err);
    };

    const FetchTrackLogs = () => {
        Axiosfetch(baseURL + "GetActiveTrackLogs", "GET", null, TrackLogsSuccess, Failure);
    };

    const TrackLogsSuccess = (data) => {
        setTrackLogData(data);
        setFilterTrackLogData(data);
        FetchUsersData();
    };

    const FetchUsersData = () => {
        FetchUsers(null, UserSuccess, Failure);
    };

    const UserSuccess = (data) => {
        let userlist = [];
        data.forEach(user => {
            if (user.Organization.length > 0) {
                userlist.push({ value: user.Organization[0]._id, label: user.FirstName + " " + user.LastName + " [" + user.Organization[0].Name + "]" });
            }
        });

        setPartnerUsers(userlist);
    };

    const OnUserChange = (user) => {
        let useData = user ? user.value : null;
        if (useData) {
            let filterTracking = TrackLogData.filter(t => t.TrackBy.length > 0 && t.TrackBy[0]._id === useData);
            setFilterTrackLogData(filterTracking);
        }
        else {
            setFilterTrackLogData(TrackLogData);
        }
    };

    const GetUserNames = (partnerlist) => {
        var listNew = "";
        if (partnerlist) {
            var partners = partnerlist.split(';');
            partners.forEach(list => {
                let usefilter = PartnerUsers.filter(u => u.value === list);
                if (usefilter.length > 0) {
                    listNew += `${usefilter[0].label} , `;
                }
            });

            listNew = listNew !== "" ? listNew.substring(0, listNew.length - 2).trim() : "";
        }

        return listNew;
    };

    const columns = [
        {
            name: 'SI #',
            width: "80px",
            selector: (row, index) => (index + 1),
            sortable: true,
        },
        {
            name: 'TripID',
            width: "225px",
            wrap: true,
            selector: row => row.TripID ? <NavLink target="_blank" title="Click to see Tracking" rel="noopener noreferrer" to={`/TrackingDetails/${row.TripID}`}>{row.TripID}</NavLink> : "-",
            sortable: true,
        },
        {
            name: 'Created Date',
            width: "150px",
            wrap: true,
            selector: row => `${moment(row.createdAt).local().format("DD/MM/YYYY")} ${moment(row.createdAt).local().format("hh:mm:ss A")}`,
        },
        {
            name: 'Origin',
            wrap: true,
            selector: row => `${row.OriginCity} (${row.OriginPinCode})`,
            sortable: true,
        },
        {
            name: 'Dest',
            wrap: true,
            selector: row => `${row.DestCity} (${row.DestPinCode})`,
            sortable: true,
        },
        {
            name: 'Truck #',
            wrap: true,
            selector: row => row.TruckNumber,
            sortable: true,
        },
        {
            name: 'Phone',
            width: "135px",
            selector: row => {
                return <div style={{
                    padding: "0 10px", borderRadius: "10px",
                    backgroundColor: "#1155ff", color: "white"
                }}><a style={{ color: "white", textDecoration: "none" }} href={`tel:+91${row.PhoneNumber}`}>{row.PhoneNumber}</a></div>
            }
        },
        {
            name: 'Track By',
            width: "180px",
            wrap: true,
            selector: row => (row.TrackBy && row.TrackBy.length > 0) ? `MFI ${row.TrackBy[0].Name}` : "",
            sortable: true,
        },
        {
            name: 'Tracking Partners',
            width: "200px",
            wrap: true,
            selector: row => GetUserNames(row.TrackPartners),
            sortable: true,
        },
        {
            name: 'Rating',
            width: "220px",
            selector: row => {
                return (row.Rating && row.Rating !== 0) ? (<div style={{ padding: "10px" }}><div style={{ display: "flex", whiteSpace: "normal" }}>
                    {Array.from({ length: 10 }).map((star, index) => (
                        <div key={index}>
                            <FontAwesomeIcon style={{ color: (row.Rating >= (index + 1) ? "orange" : "gray") }}
                                icon={faStar}></FontAwesomeIcon></div>
                    ))}

                </div>
                    <div>{row.Rating} / 10</div>
                </div>) : "-"
            }
        }
    ];

    const onCitySearch = (searchValue) => {
        if (searchValue && searchValue !== "") {
            let SearchData = TrackLogData.filter(c => c.OriginCity.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.DestCity.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterTrackLogData(SearchData);
        }
        else {
            setFilterTrackLogData(TrackLogData);
        }
    };

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="col-md-5 col-12 align-right responsive-align">
                        <h5 style={{ fontWeight: "500" }}>TrackLog Records</h5>
                    </div>
                    <div className="col-md-4 d-flex col-12 responsive-align" style={{ zIndex: "2", justifyContent: "end" }}>
                        <div className="dropdownMobile">
                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Partner"
                                options={PartnerUsers}
                                onChange={OnUserChange}></Select>
                        </div>
                    </div>
                    <div className="col-md-3 col-6" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search City..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onCitySearch(e.target.value)}></input>
                        <div style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <DataTable columns={columns} data={FilterTrackLogData}></DataTable>
                </div>
            </div>
        </div >
    );
};

export default TrackRecords;